import videojs from "video.js";
import "vpsb";
import * as EasyBroadcast from "eb";
import "hlsjs";
import {
  _getContentUrl,
  _getCodec,
  _getBandwidth,
  _getBufferLength,
  _checkBuffering,
  _startWatching,
  _stopWatching,
  _stopCheckBuffering,
} from "./hlsjs-tools.js";
import EBFragLoaderGenerator from "./hlsjs-loader";

const registerPlugin = videojs.registerPlugin || videojs.plugin;
const defaults = {
  broadcasterId: "test",
  manager: "wss://manager4.easybroadcast.fr",
};
let playerInitTime;
let getBufferInterval;
let stats;
let manager;

const onPlayerReady = (player, options) => {
  player.perSourceBehaviors();

  player.one("timeupdate", () => {
    let startTime = 0;
    if (playerInitTime !== undefined) {
      startTime = (Date.now() - playerInitTime) / 1000;
      startTime = startTime > 0 ? startTime : 0.1;
    }
    manager = new EasyBroadcast.Manager(options.broadcasterId, options.manager);

    stats = manager.getStats();

    let { url } = options;
    let codec = "notfound";
    let bandwidth = 0;

    stats.reset();
    stats.setOrigin(options.origin);
    stats.setContent(options.url.split("?")[0].replace(/(hdn).*\//g, ""));
    stats.setProtocol("hls");
    stats.setStartTime(startTime);
    stats.setState(EasyBroadcast.StatsPlayerState.PLAYING);
    _checkBuffering(player, stats);
    player.on("hlsLevelSwitched", () => {
      console.log("Source changed, re-registering");
      _stopWatching();
      player.one("timeupdate", () => {
        try {
          url = _getContentUrl(player);
          codec = _getCodec(player);
          bandwidth = _getBandwidth(player);
        } catch (err) {
          console.warn(
            `Could not get new content infos, disabling EasyBroadcast manager : ${
              err
            }`,
          );
          return;
        }
        manager.register({
          url,
          bandwidth,
          codec,
        });
        stats.setContent(url);
        stats.reset();
      });
    });

    getBufferInterval = window.setInterval(() => {
      stats.setBufferLength(_getBufferLength(player.tech_.hls));
    }, 1000);

    player.on("pause", () => {
      stats.setState(EasyBroadcast.StatsPlayerState.PAUSED);
    });

    player.on("play", () => {
      stats.setState(EasyBroadcast.StatsPlayerState.PLAYING);
    });

    player.on("playing", () => {
      stats.setState(EasyBroadcast.StatsPlayerState.PLAYING);
    });

    manager.on("connected", () => {
      console.log("Connected to EasyBroadcast manager");
      player.one("timeupdate", () => {
        try {
          url = _getContentUrl(player);
          codec = _getCodec(player);
          bandwidth = _getBandwidth(player);
        } catch (err) {
          console.warn(
            `Could not get new content infos, disabling EasyBroadcast manager : ${
              err
            }`,
          );
          return;
        }
        manager.register({
          url,
          bandwidth,
          codec,
        });
        player.tech_.hls.config.fLoader = EBFragLoaderGenerator(
          manager,
          player,
        );
      });
    });

    manager.on("disconnected", () => {
      console.warn("Disconnected from manager");
      player.tech_.hls.config.fLoader = undefined;
    });

    manager.on("warning", message => {
      console.warn(message);
    });

    manager.on("error", error => {
      console.warn(
        `EasyBroadcast manager encountered an error (${
          error
        }), falling back to normal mode`,
      );
      player.tech_.hls.config.fLoader = undefined;
      _stopWatching();
    });

    manager.on("registered", () => {
      console.log("Registered on EasyBroadcast manager");
      _startWatching(player, manager);
    });
    manager.on("unregistered", () => {
      console.log("Unregistered from EasyBroadcast manager");
    });

    manager.connect();
  });
};

const close = player => {
  manager.userClose();
  stats.stop();
  _stopCheckBuffering();
  clearInterval(getBufferInterval);
  player.tech_.hls.destroy();
};

/**
 * EasyBroadcast plugin for Video.js.
 *
 */
const easybroadcast = function(options = defaults) {
  /**
   * Why doesn't it work with "this" everywhere?
   */
  const player = this;

  player.one("play", () => {
    if (playerInitTime === undefined) {
      playerInitTime = Date.now();
    }
  });
  player.ready(() => {
    onPlayerReady(player, options);
  });
};
// Register the plugin with video.js.
registerPlugin("easybroadcast", easybroadcast);

// Include the version number.
easybroadcast.VERSION = "0.1";

export { easybroadcast, close };
export default easybroadcast;



// WEBPACK FOOTER //
// ./src/js/videoJSExtensions/easybroadcast/hlsjs-eb.js